import { render, staticRenderFns } from "./ListDistributionCenterBlockedBranchTab.vue?vue&type=template&id=2ffdc846"
import script from "./ListDistributionCenterBlockedBranchTab.vue?vue&type=script&lang=js"
export * from "./ListDistributionCenterBlockedBranchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports